'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/yearsSince.js
// module id = 615
// module chunks = 0